import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HeaderService } from '../../service/header.service';

export interface ProfileData {
  name: string;
  phone: string;
  email: string;
  login: string;
  password: string;
  occupation: string;
  companyName: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService {
  private profileDataSubject = new BehaviorSubject<ProfileData | null>(null);
  public profileData$ = this.profileDataSubject.asObservable();

  constructor(private headerService: HeaderService) {}

  loadProfileData(): Observable<any> {
    const companyID =
      localStorage.getItem('companyID') || sessionStorage.getItem('companyID');
    const restrictionKey =
      localStorage.getItem('restrictionKey') ||
      sessionStorage.getItem('restrictionKey');

    return this.headerService.listProfileData(companyID, restrictionKey).pipe(
      tap((response: any) => {
        if (response && response.data) {
          const profileData: ProfileData = {
            name: response.data.name || '',
            phone: response.data.phone || '',
            email: response.data.email || '',
            login: response.data.login || '',
            password: response.data.password || '',
            occupation: response.data.occupation || '',
            companyName: response.data.companyName || '',
          };
          this.profileDataSubject.next(profileData);
        }
      }),
    );
  }

  getProfileData(): ProfileData | null {
    return this.profileDataSubject.value;
  }

  getPassword(): string {
    return this.profileDataSubject.value?.password || '';
  }

  clearProfileData(): void {
    this.profileDataSubject.next(null);
  }
}
